import { useState, useEffect } from 'react';

/**
 * Returns true when the viewport width is at or below `breakpoint` (default 768px).
 * Re-evaluates on window resize. Safe for SSR (guards window access).
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
